/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
export const yesNoTranslation = {
  ar: [
    {
      id: 'yes',
      value: 'نعم',
      synonyms: []
    },
    {
      id: 'no',
      value: 'رقم',
      synonyms: ['ل']
    }
  ],
  cs: [
    {
      id: 'yes',
      value: 'Ano',
      synonyms: [
        'jo',
        'jiste',
        'jistě',
        'samozrejme',
        'samozřejmě',
        'jojo',
        'jj',
        'jó',
        'jóó',
        'áno'
      ]
    },
    {
      id: 'no',
      value: 'Ne',
      synonyms: ['nene', 'nn', 'nikdy', 'né', 'néé']
    }
  ],
  de: [
    {
      id: 'yes',
      value: 'Ja',
      synonyms: [
        'jawohl',
        'ja doch',
        'doch',
        'allerdings',
        'freilich',
        'sicher'
      ]
    },
    {
      id: 'no',
      value: 'Nein',
      synonyms: ['nicht', 'keineswegs']
    }
  ],
  en: [
    {
      id: 'yes',
      value: 'Yes',
      synonyms: ['yeah', 'yea', 'yup', 'sure', 'positive']
    },
    {
      id: 'no',
      value: 'No',
      synonyms: ['not', 'nope', 'nay', 'negative']
    }
  ],
  es: [
    {
      id: 'yes',
      value: 'Sí',
      synonyms: ['si', 'sii', 'seguro', 'positivo']
    },
    {
      id: 'no',
      value: 'No',
      synonyms: ['negativo']
    }
  ],
  fr: [
    {
      id: 'yes',
      value: 'Oui',
      synonyms: ['bien sur', 'bien sûr']
    },
    {
      id: 'no',
      value: 'Non',
      synonyms: ['ne pas', 'jamais pas']
    }
  ],
  it: [
    {
      id: 'yes',
      value: 'Sì',
      synonyms: ['si', 'sicuro', 'certo']
    },
    {
      id: 'no',
      value: 'Non',
      synonyms: ['no', 'mai']
    }
  ],
  ja: [
    {
      id: 'yes',
      value: 'はい',
      synonyms: ['ポジティブ']
    },
    {
      id: 'no',
      value: 'いいえ',
      synonyms: ['ネガティブ']
    }
  ],
  ko: [
    {
      id: 'yes',
      value: '네',
      synonyms: []
    },
    {
      id: 'no',
      value: '아니요',
      synonyms: ['아니']
    }
  ],
  nl: [
    {
      id: 'yes',
      value: 'Ja',
      synonyms: ['ja meneer', 'inderdaad', 'natuurlijk', 'zeker', 'positief']
    },
    {
      id: 'no',
      value: 'Nee',
      synonyms: ['niet', 'in geen geval', 'geen']
    }
  ],
  ['pt-br']: [
    {
      id: 'yes',
      value: 'Sim',
      synonyms: ['certeza', 'positivo']
    },
    {
      id: 'no',
      value: 'Não',
      synonyms: ['nao', 'nay', 'negativo']
    }
  ],
  'zh-cn': [
    {
      id: 'yes',
      value: '是',
      synonyms: ['是的', '对', '行', '可以']
    },
    {
      id: 'no',
      value: '不',
      synonyms: ['不是', '不对', '不行', '不可以']
    }
  ],
  'zh-tw': [
    {
      id: 'yes',
      value: '是',
      synonyms: ['是的', '對', '行', '可以']
    },
    {
      id: 'no',
      value: '不',
      synonyms: ['不是', '不對', '不行', '不可以']
    }
  ],
  xx: [
    {
      id: 'yes',
      value: 'Yes',
      synonyms: ['yeah', 'yea', 'yup', 'sure', 'positive']
    },
    {
      id: 'no',
      value: 'No',
      synonyms: ['not', 'nope', 'nay', 'negative']
    }
  ]
};

export const searchSettingsTranslation = {
  ['pt-br']: {
    messages: {
      error:
        'Posso ter informações relacionadas à sua consulta para compartilhar, mas não consigo me conectar à minha base de conhecimento no momento',
      no_result:
        'Pesquisei minha base de conhecimento, mas não encontrei nada relacionado à sua consulta',
      success:
        'Pesquisei minha base de conhecimento e encontrei esta informação que pode ser útil'
    }
  },
  en: {
    messages: {
      error:
        'I might have information related to your query to share, but am unable to connect to my knowledge base at the moment',
      no_result:
        'I searched my knowledge base, but did not find anything related to your query',
      success:
        'I searched my knowledge base and found this information which might be useful'
    }
  },
  es: {
    messages: {
      error:
        'Es posible que tenga información relacionada con su consulta para compartir, pero no puedo conectarme a mi base de conocimientos en este momento.',
      no_result:
        'Busqué en mi base de conocimientos, pero no encontré nada relacionado con tu consulta.',
      success:
        'Busqué en mi base de conocimientos y encontré esta información que podría ser útil.'
    }
  },
  de: {
    messages: {
      error:
        'Möglicherweise möchte ich Informationen zu Ihrer Anfrage weitergeben, kann aber derzeit keine Verbindung zu meiner Wissensdatenbank herstellen',
      no_result:
        'Ich habe meine Wissensdatenbank durchsucht, aber nichts zu Ihrer Anfrage gefunden',
      success:
        'Ich habe meine Wissensdatenbank durchsucht und diese Informationen gefunden, die nützlich sein könnten'
    }
  },
  fr: {
    messages: {
      error:
        "J'ai peut-être des informations à partager concernant votre requête, mais je ne parviens pas à me connecter à ma base de connaissances pour le moment.",
      no_result:
        "J'ai cherché dans ma base de connaissances, mais je n'ai rien trouvé en rapport avec votre requête",
      success:
        "J'ai cherché dans ma base de connaissances et trouvé cette information qui pourrait être utile"
    }
  }
};
